define('NewsLetterForm.Confirmation.View',
[
    'newsletter_confirmation.tpl',
    'underscore',
    'Backbone'
],
function (newsletter_confirmation,
          _,
          Backbone) {

    'use strict';

    return Backbone.View.extend({


        template: newsletter_confirmation

        , initialize: function (options) {
        }

        , getContext: function () {
            return {
            };
        }

    })
})
